import { render, staticRenderFns } from "./validChannelsPieChart.vue?vue&type=template&id=85d5e2c2"
import script from "./validChannelsPieChart.vue?vue&type=script&lang=js"
export * from "./validChannelsPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports